import { SnapshotRequestMsg } from '#websocket/client/proto';
import { SnapshotRequest } from './common';
export class CreateSnapshotRequest extends SnapshotRequest {
    constructor(snapshotLabel, destination) {
        super({ type: SnapshotRequestMsg.RequestType.CREATE_SNAPSHOT_REQUEST, snapshotLabel }, destination);
    }
}
